/** Shared pricing translation shape — imported by all locale files. */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const pricingTranslationsFr = {
  eyebrow: 'Forfaits et tarifs',
  perMonth: 'par mois',
  perYear: 'par an',
  copy: {
    pageTitle: 'Forfaits et tarifs',
    pageSubtitle:
      'Un seul endroit pour comparer les forfaits. Hobby est gratuit pour tous. Pro est un abonnement personnel. Business est des frais org WC 2026 uniques (pas Pro). Enterprise se négocie avec notre équipe.',
    comingSoonBadge: 'Bientôt disponible',
    comingSoonInProduction: 'Bientôt disponible en production',
    mostPopularBadge: 'Le plus populaire',
    currentPlanBadge: 'Votre forfait',
    createOrgCta: 'Créer une organisation',
    footnote:
      'Pro est facturé sur votre compte personnel (sans organisation). Business est des frais organisation WC 2026 uniques — créez une organisation, choisissez votre tranche de sièges et payez une fois pour l’accès org pendant le tournoi. Enterprise s’adresse aux organisations qui ont besoin de tarifs, limites ou contrats sur mesure — contactez-nous.',
    orgPlanDisclosure: WC2026_ORG_BILLING_DISCLOSURE,
    orgPlanDisclosureShort: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    footnoteCancelPolicy:
      'Si vous résiliez Pro dans le portail de facturation, Stripe maintient votre forfait actif jusqu’à la fin de la période payée — vous pouvez le reprendre avant cette date. L’application se synchronise avec Stripe lorsque vous revenez ici.',
    signInToSubscribe: 'Connectez-vous pour vous abonner',
    logIn: 'Se connecter',
    goBack: 'Retour',
    manageSubscription: 'Gérer l’abonnement',
    proAccessEndsOn: 'Accès Pro jusqu’au',
    billingIntervalMonth: 'Mensuel',
    billingIntervalYear: 'Annuel',
    switchToMonthly: 'Passer au mensuel',
    upgradeToYearlyDialogMsg:
      'La facturation annuelle est un engagement de 12 mois. Une fois basculé, vous ne pourrez plus revenir à la facturation mensuelle avant la fin de votre période annuelle — pas de remboursement partiel.',
    upgradeToYearlyDialogConfirm: 'Passer à l’annuel',
    upgradeToYearlyDialogCancel: 'Rester en mensuel',
    switchToMonthlyDialogTitle: 'Passer au Pro mensuel',
    switchToMonthlyDialogMsg:
      'Vous serez redirigé vers Stripe pour passer à la facturation mensuelle. Votre accès Pro annuel continue jusqu’à la fin de la période en cours — la facturation mensuelle commence ensuite. Aucun remboursement pour le temps non utilisé.',
    switchToMonthlyConfirm: 'Aller sur Stripe',
    switchToMonthlyCancel: 'Rester en annuel',
    upgradeToYearlyProTitle: 'Passer au Pro annuel',
    upgradeToYearlyProConfirm: 'Mettre à niveau',
    enterpriseSubscribe: 'S’abonner',
    enterpriseCheckoutAdminOnly: 'Demandez à un administrateur de l’organisation de s’abonner',
    upgradeSeatBucket: 'Mettre à niveau',
    managePlan: 'Forfait et facturation',
    businessSubscribe: 'S’abonner',
    upgradeMonthlyToYearlyDialog: {
      line1: 'Vous passez du Pro mensuel ({monthly}/mois) au Pro annuel ({yearly}/an).',
      line2:
        'Votre moyen de paiement enregistré sera débité de la différence au prorata pour la période de facturation en cours.',
      line3:
        'Une fois en annuel, vous ne pourrez plus revenir à la facturation mensuelle avant la fin de la période annuelle.',
      line4: 'Continuer ?',
    },
  },
  plans: {
    hobby: {
      name: 'Hobby',
      priceLabel: 'Gratuit',
      tagline: 'Pour les amis et les petits groupes qui débutent.',
      ctaLabel: 'Commencer',
      features: [
        'Défis et pronostics essentiels',
        'Score standard (sans doubles)',
        'Lignes de match standard par défi',
        'Support standard',
        'Publicités occasionnelles',
        'Idéal pour essayer Zporti avec quelques personnes',
      ],
    },
    proMonthly: {
      name: 'Pro · Mensuel',
      tagline: 'Pour les joueurs solo et les groupes d’amis qui veulent plus de fonctionnalités.',
      ctaLabel: 'S’abonner mensuellement',
      features: [
        'Tout ce qui est inclus dans Hobby',
        'Doubles activés',
        'Plus de lignes de match par défi',
        'Expérience sans publicité',
        'Limites plus élevées pour les membres et l’activité',
        'Support prioritaire',
        'Options de personnalisation avancées',
      ],
    },
    proYearly: {
      name: 'Pro · Annuel',
      tagline: 'Les mêmes fonctionnalités Pro, facturées une fois par an — idéal quand votre groupe est engagé sur la durée.',
      ctaLabel: 'S’abonner annuellement',
      features: [
        'Tout ce qui est inclus dans Hobby',
        'Doubles activés',
        'Plus de lignes de match par défi',
        'Expérience sans publicité',
        'Limites plus élevées pour les membres et l’activité',
        'Support prioritaire',
        'Options de personnalisation avancées',
      ],
    },
    business: {
      name: 'Business',
      priceLabel: 'From $450',
      tagline: 'Frais org WC 2026 uniques. Choisissez votre tranche de sièges et payez une fois pour l’accès tournoi.',
      ctaLabel: 'Commencer',
      features: [
        'Image de marque organisation (couleurs et logos)',
        'Sièges membres — tranches forfaitaires jusqu’à 2 000',
        'Accès org tournoi WC 2026 (org brandée + équipe liée)',
        'Support prioritaire',
        'N’inclut pas Pro personnel, pièces, boosts ni achats en boutique in-app',
      ],
    },
    enterprise: {
      name: 'Enterprise',
      priceLabel: 'Sur mesure',
      tagline: 'Tarifs et déploiement org négociés pour WC 2026 — définis dans votre commande ou contrat.',
      ctaLabel: 'Nous contacter',
      features: [
        'Image de marque et déploiement organisation (selon accord)',
        'Limites de membres définies avec les ventes',
        'WC 2026 et fonctionnalités organisation (selon accord)',
        'Support dédié et onboarding personnalisé',
        'Intégrations sur mesure, facturation et contrats',
        'N’inclut pas Pro personnel, pièces, boosts ni achats en boutique in-app',
      ],
    },
  },
  seatBuckets: {
    upTo100: 'Jusqu’à 100 employés',
    upTo250: 'Jusqu’à 250 employés',
    upTo500: 'Jusqu’à 500 employés',
    upTo1000: 'Jusqu’à 1 000 employés',
    upTo2000: 'Jusqu’à 2 000 employés',
  },
} as const

export const featuresSectionFr = {
  eyebrow: 'Ce que vous obtenez',
  livePreview: 'Aperçu en direct',
  avatars: {
    title: 'Des avatars personnalisés pour chaque joueur',
    description:
      'Donnez à chaque personne une identité reconnaissable pour que les classements, les rivalités et les taquineries prennent vie dès le premier jour.',
    accessibilityLabel: 'Aperçu de la fonctionnalité avatars personnalisés',
  },
} as const

export const footerExtendedFr = {
  product: 'Produit',
  compete: 'Compétition',
  company: 'Entreprise',
  phoneTagline: 'Pronostics sportifs entre amis.',
  copyright: '© 2026 Zporti. Créé par des fans de football, pour des fans de football.',
  copyrightShort: '© 2026 Zporti',
} as const

export const organizationsFr = {
  heroBadge: 'Pour équipes, ligues et marques',
  heroTitle: 'Organisations sur Zporti',
  heroLead:
    'Gérez votre groupe avec sa propre identité dans Zporti. Définissez couleurs et logos de marque, invitez des membres avec un code d’adhésion et gérez les places depuis un seul endroit — pour une expérience cohérente quand tout le monde joue et pronostique ensemble.',
  valueSectionTitle: 'Ce que vous obtenez',
  valueBrandingTitle: 'Une marque qui vous ressemble',
  valueBrandingBody:
    'Téléversez vos logos, choisissez les couleurs principales et secondaires, et prévisualisez leur rendu dans l’expérience. Les administrateurs gardent une identité visuelle cohérente sans toucher au code.',
  valueMembersTitle: 'Membres et places',
  valueMembersBody:
    'Créez une organisation ou rejoignez-en une avec un code. Voyez qui est inscrit, gérez la capacité selon les limites de votre forfait et copiez un code d’adhésion pour accueillir de nouvelles personnes.',
  valueMascotTitle: 'Mascotte et avatars de marque',
  valueMascotBody:
    'Des humeurs de mascotte personnalisées et des ensembles d’avatars réservés à l’organisation aident votre communauté à se démarquer — idéal pour les groupes de supporters, les ligues d’entreprise et les partenaires.',
  howSectionTitle: 'Comment ça marche',
  howStep1: 'Connectez-vous, puis créez une organisation ou rejoignez-en une avec un code d’invitation de votre administrateur.',
  howStep2: 'Les administrateurs ouvrent les paramètres de l’organisation pour ajuster l’image de marque, les membres et les détails du compte.',
  howStep3: 'Les membres utilisent l’application comme d’habitude, avec les visuels et avantages de votre organisation lorsqu’ils sont activés.',
  signIn: 'Se connecter',
  signUp: 'Créer un compte',
  heroPanelTitle: 'Centre de contrôle organisation',
  heroPanelBody:
    'Invitez des membres, définissez votre marque et offrez à chaque groupe une vitrine soignée avant le coup d\'envoi.',
} as const

export const b2bContactFr = {
  title: 'Vous préférez que nous le configurions pour vous ?',
  subtitle: 'Remplissez vos coordonnées et notre équipe vous contactera.',
  orgNameLabel: 'Nom de l’organisation *',
  orgNamePlaceholder: 'Votre organisation',
  contactNameLabel: 'Votre nom *',
  contactNamePlaceholder: 'Nom complet',
  emailLabel: 'E-mail *',
  emailPlaceholder: 'vous@exemple.com',
  messageLabel: 'Message',
  messagePlaceholder: 'Parlez-nous de vos besoins (facultatif)',
  submitButton: 'Envoyer la demande',
  scheduleMemo: 'Ou planifier un appel — bientôt disponible',
  errorFallbackValidation: 'Vérifiez vos informations et réessayez.',
  errorFallbackSubmit: 'L’envoi a échoué. Veuillez réessayer.',
  successMessage: 'Merci ! Nous avons bien reçu votre demande et vous contacterons prochainement.',
} as const

export const signInFr = {
  signUpSubtitle: 'Inscrivez-vous pour commencer',
  signInSubtitle: 'Connectez-vous pour continuer',
  emailPlaceholder: 'E-mail',
  passwordPlaceholder: 'Mot de passe',
  forgotPassword: 'Mot de passe oublié ?',
  signUpButton: 'S’inscrire',
  signInButton: 'Se connecter',
  alreadyHaveAccount: 'Vous avez déjà un compte ? ',
  noAccount: 'Vous n’avez pas de compte ? ',
  toggleSignIn: 'Se connecter',
  toggleSignUp: 'S’inscrire',
  orDivider: 'OU',
  signInWith: 'Se connecter avec',
  continueAsGuest: 'ou continuer en invité',
  legalConsentPrefix: 'J’ai lu et j’accepte les ',
  legalConsentAnd: ' et la ',
  legalConsentSuffix: '.',
  marketingConsent: 'J’accepte de recevoir des actualités produit et des e-mails marketing de Zporti.',
  loading: 'Chargement…',
  sendingResetEmail: 'Envoi de l’e-mail de réinitialisation',
  signingUp: 'Inscription en cours',
  signingIn: 'Connexion en cours',
  continuingWithGoogle: 'Connexion avec Google',
  continuingWithFacebook: 'Connexion avec Facebook',
  enteringAsGuest: 'Accès en tant qu’invité',
} as const

export const a11yFr = {
  openMenu: 'Ouvrir le menu',
  closeMenu: 'Fermer le menu',
  heroMascot: 'Mascotte Zporti tenant un téléphone',
} as const

export const accountAdminSiteFr = {
  backToSite: '← Retour au site',
} as const
